import {
  Cancel,
  CheckCircleOutline,
  ErrorOutline,
  HourglassEmpty,
  Warning,
} from "@mui/icons-material";
import { Chip, Tooltip } from "@mui/material";

import React from "react";
import { StatusChipProps } from "./types";

const StatusChip: React.FC<StatusChipProps> = ({
  status,
  errorMessage,
  rejectionReason,
}) => {
  const getStatusConfig = () => {
    switch (status) {
      case "approved":
        return {
          label: "Approved",
          color: "success",
          icon: <CheckCircleOutline fontSize="small" />,
          tooltipText: "Action has been approved",
        };
      case "rejected":
        return {
          label: "Rejected",
          color: "error",
          icon: <Cancel fontSize="small" />,
          tooltipText: rejectionReason
            ? `Rejected: ${rejectionReason}`
            : "Action has been rejected",
        };
      case "pending":
        return {
          label: "Pending",
          color: "warning",
          icon: <HourglassEmpty fontSize="small" />,
          tooltipText: "Action is awaiting approval",
        };
      case "execution_failed":
        return {
          label: "Failed",
          color: "error",
          icon: <ErrorOutline fontSize="small" />,
          tooltipText: errorMessage
            ? `Error: ${errorMessage}`
            : "Execution failed",
        };
      case "completed":
        return {
          label: "Completed",
          color: "success",
          icon: <CheckCircleOutline fontSize="small" />,
          tooltipText: "Action has been completed successfully",
        };
      default:
        return {
          label: status || "Unknown",
          color: "default",
          icon: <Warning fontSize="small" />,
          tooltipText: "Unknown status",
        };
    }
  };

  const { label, color, icon, tooltipText } = getStatusConfig();

  return (
    <Tooltip title={tooltipText} arrow placement="top">
      <Chip
        icon={icon}
        label={label}
        color={
          color as
            | "default"
            | "primary"
            | "secondary"
            | "error"
            | "info"
            | "success"
            | "warning"
        }
        size="small"
        sx={{
          fontWeight: 500,
          fontSize: "0.75rem",
          "& .MuiChip-icon": {
            ml: 0.5,
          },
        }}
      />
    </Tooltip>
  );
};

export default StatusChip;
